<app-notes [moduleId]="moduleId" [entityId]="entityId" urlPrefix="/client/location"></app-notes>